import { Loader } from "@googlemaps/js-api-loader";

const apiKey = process.env.GOOGLE_PLACES_JS_API_KEY;

const loader = new Loader({
  apiKey,
  version: "weekly",
  libraries: ["places"]
});

export default loader;
